document.addEventListener('DOMContentLoaded', () => {
  const cartWrapper = document.getElementById('main-cart');
  if (!cartWrapper) return;

  let debounceTimer;

  // HIER IST DIE MAGIE: Das 'true' am Ende aktiviert die Capture-Phase!
  cartWrapper.addEventListener('click', (e) => {
    
    // 1. Klick auf Plus/Minus
    const btn = e.target.closest('.quantity__button');
    if (btn) {
      e.preventDefault();
      e.stopPropagation(); // Stoppt das Event auf dem Weg nach unten!
      
      const input = btn.parentElement.querySelector('.quantity__input');
      let val = parseInt(input.value);
      
      if (btn.name === 'plus') val++;
      if (btn.name === 'minus') val--;
      if (val < 0) val = 0;
      
      input.value = val;
      triggerQuantityUpdate(input.dataset.index, val);
    }

    // 2. Klick auf den Mülleimer
    const removeBtn = e.target.closest('cart-remove-button a, cart-remove-button');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation(); // Blockiert das Shopify-Theme VOR der Ausführung!
      
      const removeUrl = removeBtn.getAttribute('href') || removeBtn.querySelector('a').getAttribute('href'); 
      triggerRemoveByUrl(removeUrl);
    }
  }, true); // <--- DIESES TRUE IST DER LEBENSRETTER

  // Manuelle Eingabe per Tastatur abfangen
  cartWrapper.addEventListener('change', (e) => {
    if (e.target.classList.contains('quantity__input')) {
      e.stopPropagation();
      triggerQuantityUpdate(e.target.dataset.index, e.target.value);
    }
  }, true); // <--- Auch hier Capture Phase

  // --- FUNKTIONEN ---

  function triggerQuantityUpdate(lineIndex, newQuantity) {
    clearTimeout(debounceTimer);
    setLoadingState();

    debounceTimer = setTimeout(() => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: newQuantity })
      })
      .then(() => fetchNewCartHTML())
      .catch(err => console.error(err));
    }, 300);
  }

  function triggerRemoveByUrl(url) {
    clearTimeout(debounceTimer);
    setLoadingState();

    fetch(url, { method: 'POST' })
    .then(() => fetchNewCartHTML())
    .catch(err => console.error(err));
  }

  function setLoadingState() {
    const cartItems = document.getElementById('main-cart-items');
    if(cartItems) cartItems.style.opacity = '0.5';
  }

  function fetchNewCartHTML() {
    const sectionId = document.getElementById('main-cart-items').dataset.id;
    
    fetch(window.location.pathname + '?section_id=' + sectionId)
    .then(res => res.text())
    .then(html => {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      
      const targetItems = document.getElementById('main-cart-items');
      const sourceItems = parsedHTML.getElementById('main-cart-items');
      if (targetItems && sourceItems) targetItems.innerHTML = sourceItems.innerHTML;

      const targetFooter = document.getElementById('main-cart-footer');
      const sourceFooter = parsedHTML.getElementById('main-cart-footer');
      if (targetFooter && sourceFooter) targetFooter.innerHTML = sourceFooter.innerHTML;

      if(targetItems) targetItems.style.opacity = '1';
    });
  }
});